import { noChange } from 'lit';
import { directive, Directive } from 'lit/directive.js';
import { extractDeclarativeElement } from './directive-helpers';
/** Assign an object matching an element's inputs to its inputs. */
export function assign(declarativeElement, inputsObject) {
    /**
     * The directive generics (in listenDirective) are not strong enough to maintain their values.
     * Thus, the directive call is wrapped in this function.
     */
    return assignDirective(declarativeElement, inputsObject);
}
const assignDirective = directive(class extends Directive {
    constructor(partInfo) {
        super(partInfo);
        this.element = extractDeclarativeElement(partInfo, 'assign');
    }
    render(elementDefinition, inputsObject) {
        assignInputsObject(elementDefinition, this.element, inputsObject);
        return noChange;
    }
});
export function assignInputsObject(expectedElementConstructor, element, assignmentObject) {
    if (element.tagName.toLowerCase() !== expectedElementConstructor.tagName.toLowerCase()) {
        console.error(element, expectedElementConstructor);
        throw new Error(`Assignment mismatch. Assignment was made for ${element.tagName.toLowerCase()} but it's attached to ${expectedElementConstructor.tagName.toLowerCase()}`);
    }
    element.assignInputs(assignmentObject);
}
